// extracted by mini-css-extract-plugin
export default {"alreadyRegisteredLoginWrapper":"alreadyRegisteredLoginWrapper__gv0g1","loginWrapper":"loginWrapper__fRtTJ","show":"show__hPwUk"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"alreadyRegisteredLoginWrapper\":\"alreadyRegisteredLoginWrapper__gv0g1\",\"loginWrapper\":\"loginWrapper__fRtTJ\",\"show\":\"show__hPwUk\"}";
        // 1787130556876
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  